// api.js
import { getToken } from "./tokenStorage";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_API_URL; // Replace with your actual API URL
// const BASE_URL = 'http://34.228.222.160:3000/api/v1'; // Replace with your actual API URL

const makeAuthenticatedRequest = async (
  url,
  method = "GET",
  body = null,
  customBaseUrl = null,
  timeout = 180000 // default 180 seconds
) => {
  const token = await getToken();
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const baseUrl = customBaseUrl || BASE_URL;

  // Create an AbortController for timeout
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);

  try {
    const response = await fetch(`${baseUrl}${url}`, {
      method,
      headers,
      body,
      signal: controller.signal,
    });

    return response;
  } catch (err) {
    if (err.name === "AbortError") {
      throw new Error("Request timed out");
    }
    throw err;
  } finally {
    clearTimeout(id);
  }
};

const makeAuthenticatedRequestForJoinEndLiveClass = async (
  url,
  method = "POST",
  body = null
) => {
  const token = await getToken();
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  // Continue with the original request
  return await fetch(`${BASE_URL}${url}`, { method, headers, body });
};

const makeAuthenticatedRequestForFile = async (
  url,
  method = "GET",
  body = null
) => {
  const token = await getToken();
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  // Continue with the original request
  return await fetch(`${BASE_URL}${url}`, { method, headers, body });
};

const makeAuthenticatedRequestWithHandling = async (
  url,
  method = "GET",
  body = null,
  toastText = null
) => {
  try {
    const token = await getToken();
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    const response = await fetch(`${BASE_URL}${url}`, {
      method,
      headers,
      body,
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData?.error || `Request failed with status ${response.status}`
      );
    }
    if (toastText?.toastText) {
      toast.success(toastText.toastText);
    }
    return response;
  } catch (error) {
    console.error("Fetch error:", error);
    throw new Error(error?.message || "Request failed");
  }
};

const loginRequest = async (credentials) => {
  try {
    const response = await fetch(`${BASE_URL}/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(credentials),
    });

    if (!response.ok) {
      const errorData = await response.json();
      return {
        ok: false,
        error: errorData.error || "Login failed",
        email: errorData.email || null, // Return email if available in the error response
      };
    }

    return { ok: true, data: await response.json() };
  } catch (error) {
    console.error("Login error:", error);
    return { ok: false, error: error.message };
  }
};

export {
  makeAuthenticatedRequest,
  makeAuthenticatedRequestForFile,
  makeAuthenticatedRequestWithHandling,
  makeAuthenticatedRequestForJoinEndLiveClass,
  loginRequest,
};
